import { StockList } from "./StockList";

export default StockList;
